import jq from "jquery";
import store from "@/store";
import { getUuid } from '@/utils'
import md5 from "js-md5";
var uid = ''
var sign = ''
var token = window.localStorage.getItem("xc-share-accessToken");
var expiresIn = window.localStorage.getItem("xc-share-expiresIn");
var tokenType = window.localStorage.getItem("xc-share-tokenType");
let tokenTime = window.localStorage.getItem("xc-share-tokenTime");
var refreshToken = localStorage.getItem("xc-share-refreshToken");
var scope = localStorage.getItem("xc-share-scope");
var webClient = 'web'
export default {

  // 默认请求
  requestDefault: function (url, params, type, dataType) {
    let reqUrl = process.env.VUE_APP_API_PREFIX
    if (params.isType == 'weixin') {
      reqUrl = 'https://fzapi.farmer.com.cn/wx'
    }
    return jq.ajax({
      type: type ? type : 'post',
      url: reqUrl + url,
      data: params,
      dataType: dataType ? dataType : 'json'
    });
  },
  requestWithToken: function (url, params, type, dataType, header) {
    var me = this;
    let reqUrl = process.env.VUE_APP_API_PREFIX
    if (url == '/member/anonymous/amc/getWeiXinTicket') {
      reqUrl = 'https://fzapi.farmer.com.cn/wx'
    }
    return new Promise((resolve, reject) => {
      let time = new Date().getTime();

      this.getSign(url)

      if (!!params && Object.prototype.hasOwnProperty.call(params, "isLogin") && params.isLogin) {
        // 登录
        return this.getToken(params).then((data) => {
          this.getSign(url)
          let headersObj = {
            ...header
          }
          if (webClient) {
            headersObj.webClient = webClient
          }
          jq.ajax({
            type: type ? type : 'post',
            url: reqUrl + url,
            headers: {
              Authorization: tokenType + " " + token,
              Version: process.env.VUE_APP_VERSION,
              uid: uid,
              sign: sign,
              ...headersObj
            },
            data: params,
            dataType: dataType ? dataType : 'json',
            success: function (res) {
              resolve(res);
            },
            error: function (err) {
              reject(err);
            }
          });
        });
      } else if (!!token && !!tokenType && !!expiresIn && !!tokenTime) {
        // 有token时，先判断token是否过期
        if ((time - parseInt(tokenTime)) > (parseInt(expiresIn) - 5) * 1000) {
          // token过期，就先刷新token，然后请求数据接口
          console.log("刷新token");
          return this.refreshToken().then((data) => {
            this.getSign(url)
            let headers = {
              Authorization: data.token_type + " " + data.access_token,
              Version: process.env.VUE_APP_VERSION,
              uid: uid,
              sign: sign,
              ...header
            }
            if (webClient) {
              headers.webClient = webClient
            }
            jq.ajax({
              type: type ? type : 'post',
              url: reqUrl + url,
              headers: headers,
              data: params,
              dataType: dataType ? dataType : 'json',
              success: function (res) {
                resolve(res);
              },
              error: function (err) {
                reject(err);
              }
            });
          });
        } else {
          // token 没过期
          let headers = {
            Authorization: tokenType + " " + token,
            Version: process.env.VUE_APP_VERSION,
            uid: uid,
            sign: sign,
            ...header
          }
          if (webClient) {
            headers.webClient = webClient
          }
          jq.ajax({
            type: type ? type : 'post',
            url: reqUrl + url,
            headers: headers,
            data: params,
            dataType: dataType ? dataType : 'json',
            success: function (res) {
              resolve(res);
            },
            error: function (err) {
              console.log('err', err)
              if (err.responseJSON && err.responseJSON.code == 401) {
                window.localStorage.removeItem("xc-share-userInfo");
                window.localStorage.removeItem("xc-share-accessToken");
                window.localStorage.removeItem("xc-share-refreshToken");
                window.localStorage.removeItem("xc-share-expiresIn");
                window.localStorage.removeItem("xc-share-tokenType");
                window.localStorage.removeItem("xc-share-tokenTime");
                window.localStorage.removeItem("xc-share-scope");
                window.localStorage.removeItem("xc-share-wx-accessToken");
                window.localStorage.removeItem("xc-share-wx-refreshToken");
                window.localStorage.removeItem("xc-share-wx-expiresIn");
                window.localStorage.removeItem("xc-share-wx-tokenType");
                window.localStorage.removeItem("xc-share-wx-tokenTime");
                window.localStorage.removeItem("xc-share-wx-scope");
                me.getToken(params).then((data) => {
                  me.requestWithToken(url, params, type, dataType, header);
                });
              } else {
                reject(err);
              }
            }
          });
        }
      } else {
        // 先获取token，然后请求数据接口

        return this.getToken({ type: 'shi' }).then((data) => {
          this.getSign(url)
          let headers = {
            Authorization: tokenType + " " + token,
            Version: process.env.VUE_APP_VERSION,
            uid: uid,
            sign: sign,
            ...header
          }
          if (webClient) {
            headers.webClient = webClient
          }
          jq.ajax({
            type: type ? type : 'post',
            url: reqUrl + url,
            headers: headers,
            data: params,
            dataType: dataType ? dataType : 'json',
            success: function (res) {
              resolve(res);
            },
            error: function (err) {
              reject(err);
            }
          });
        }).catch(err => {
          reject(err);
        });
      }
    });
  },
  requestWithToken2: function (url, params, type, dataType, obj, headers, processFun) {
    var me = this;
    if (!obj) obj = {}
    if (!headers) headers = {}

    let xhr = {};
    if (processFun) {
      xhr = {
        xhr: me.xhrOnProgress(processFun),
      }
    }

    return new Promise((resolve, reject) => {

      let time = new Date().getTime();

      this.getSign(url)
      headers.uid = uid,
        headers.sign = sign
      if (webClient) {
        headers.webClient = webClient
      }

      if (!!token && !!tokenType && !!expiresIn && !!tokenTime) {
        // 有token时，先判断token是否过期
        if ((time - parseInt(tokenTime)) > (parseInt(expiresIn) - 5) * 1000) {
          // token过期，就先刷新token，然后请求数据接口
          console.log("刷新token");
          return this.refreshToken().then((data) => {
            this.getSign(url)
            headers.uid = uid,
              headers.sign = sign
            if (webClient) {
              headers.webClient = webClient
            }
            jq.ajax({
              type: type ? type : 'post',
              url: process.env.VUE_APP_API_PREFIX + url,
              headers: {
                Authorization: data.token_type + " " + data.access_token,
                Version: process.env.VUE_APP_VERSION,
                ...headers,
              },
              ...xhr,
              data: params,
              dataType: dataType ? dataType : 'json',
              ...obj,
              success: function (res) {
                resolve(res);
              },
              error: function (err) {
                reject(err);
              }
            });
          });
        } else {
          // token 没过期
          console.log("缓存token");
          jq.ajax({
            type: type ? type : 'post',
            url: process.env.VUE_APP_API_PREFIX + url,
            headers: {
              Authorization: tokenType + " " + token,
              Version: process.env.VUE_APP_VERSION,
              ...headers,
            },
            ...xhr,
            data: params,
            dataType: dataType ? dataType : 'json',
            ...obj,
            success: function (res) {
              resolve(res);
            },
            error: function (err) {
              if (err.responseJSON && err.responseJSON.code == 401) {
                window.localStorage.removeItem("xc-share-userInfo");
                window.localStorage.removeItem("xc-share-accessToken");
                window.localStorage.removeItem("xc-share-refreshToken");
                window.localStorage.removeItem("xc-share-expiresIn");
                window.localStorage.removeItem("xc-share-tokenType");
                window.localStorage.removeItem("xc-share-tokenTime");
                window.localStorage.removeItem("xc-share-wx-accessToken");
                window.localStorage.removeItem("xc-share-wx-refreshToken");
                window.localStorage.removeItem("xc-share-wx-expiresIn");
                window.localStorage.removeItem("xc-share-wx-tokenType");
                window.localStorage.removeItem("xc-share-wx-tokenTime");
                window.localStorage.removeItem("xc-share-wx-scope");
                me.getToken(params).then((data) => {
                  me.requestWithToken(url, params, type, dataType);
                });
              } else {
                reject(err);
              }
            }
          });
        }
      } else {
        // 先获取token，然后请求数据接口
        return this.getToken(null).then((data) => {
          jq.ajax({
            type: type ? type : 'post',
            url: process.env.VUE_APP_API_PREFIX + url,
            headers: {
              Authorization: data.token_type + " " + data.access_token,
              Version: process.env.VUE_APP_VERSION,
              ...headers,
            },
            ...xhr,
            data: params,
            dataType: dataType ? dataType : 'json',
            ...obj,
            success: function (res) {
              resolve(res);
            },
            error: function (err) {
              reject(err);
            }
          });
        }).catch(err => {
          reject(err);
        });
      }
    });
  },
  getToken: function (data) {
    return new Promise((resolve, reject) => {
      return store.dispatch("app/GetToken", data).then(res => {
        console.log('请求token==resolve')
        // alert('res'+JSON.stringify(res))
        resolve(res)
      });
    });
  },
  refreshToken: function () {
    return new Promise((resolve, reject) => {
      return store.dispatch("app/RefreshToken").then(res => {
        resolve(res)
      });
    });
  },
  // 获取上传进度
  xhrOnProgress(fun) {
    let me = this;
    me.xhrOnProgress.onprogress = fun; //绑定监听
    //使用闭包实现监听绑
    return function () {
      //通过$.ajaxSettings.xhr();获得XMLHttpRequest对象
      var xhr = jq.ajaxSettings.xhr();
      //判断监听函数是否为函数
      if (typeof me.xhrOnProgress.onprogress !== 'function')
        return xhr;
      //如果有监听函数并且xhr对象支持绑定时就把监听函数绑定上去
      if (me.xhrOnProgress.onprogress && xhr.upload) {
        xhr.upload.onprogress = me.xhrOnProgress.onprogress;
      }
      return xhr;
    }
  },
  // 获取sign和uid
  getSign: function (url) {
    var time = new Date().getTime();
    token = window.localStorage.getItem("xc-share-accessToken");
    expiresIn = window.localStorage.getItem("xc-share-expiresIn");
    tokenType = window.localStorage.getItem("xc-share-tokenType");
    tokenTime = window.localStorage.getItem("xc-share-tokenTime");
    refreshToken = localStorage.getItem("xc-share-refreshToken");
    scope = localStorage.getItem("xc-share-scope");

    // if (url == '/member/anonymous/amc/getWeiXinTicket') {
    //   token = window.localStorage.getItem("xc-share-wx-accessToken");
    //   expiresIn = window.localStorage.getItem("xc-share-wx-expiresIn");
    //   tokenType = window.localStorage.getItem("xc-share-wx-tokenType");
    //   tokenTime = window.localStorage.getItem("xc-share-wx-tokenTime");
    //   refreshToken = localStorage.getItem("xc-share-wx-refreshToken");
    //   scope = localStorage.getItem("xc-share-wx-scope");
    // }
    uid = getUuid()

    if (scope == "client") {
      webClient = 'web'
      sign = md5(token + uid + webClient + refreshToken + scope)
    } else {
      webClient = null
      sign = md5(token + uid + refreshToken + scope)
    }
  }
}